import React from 'react'
import './FormComponent.css';
// import bg from './bg.jpeg';
// const GOOGLE_SHEET_WEBHOOK = "https://script.google.com/macros/s/AKfycbxOzPmVyMCJphBCU5WEJo8MC6M4NAr1VM0f_FSP_qyPhj9B3KOJZ7Ma9y3cxa11IwMO/exec"; // replace this
//https://script.google.com/macros/s/AKfycbw6A0VIkHU5WOKdvDG-ko3NU6pimEdVjaQu_SkBe2hn7aiC54kicZSXw50-F0rT4qKT/exec
const FormComponent = () => {

    const handleSubmit = (e)=>{
        e.preventDefault()
        const url = "https://script.google.com/macros/s/AKfycbwUKUXszqr5WZwwCiiPepE0Xz3jWx6Neo6IX_dXOvivoQZsrgq4uKH1wq7UST7TmLSf/exec"
        fetch(url,{
            method:"POST",
            headers:{ "Content-Type": "application/x-www-form-urlencoded" },
            body:(`problem=${e.target.problem.value}&reason=${e.target.reason.value}&message=${e.target.message.value}&dropdown=${e.target.dropdown.value}&dropdown2=${e.target.dropdown2.value}&severity=${e.target.severity.value}`)
        }).then(res=>res.text()).then(data=>{
            alert(data)
        }).catch(error=>console.log(error))
    }

      return (
        <div className="form-wrapper">
        <form className="fancy-form" onSubmit={handleSubmit}>
      <h2>Tell Me What's Wrong 💌</h2>

      <input name="problem" placeholder="Problem" />
      <input name="reason" placeholder="Reason" />
      <textarea name="message" placeholder="Message"></textarea>

      <label>
        MOOD
        <select name="dropdown" placeholder="Dropdown">
    
         <option value="Extremely happy 🤣" selected>Extremely happy 🤣</option>
<option value="Confused 🤪">Confused 🤪</option>
<option value="Feeling lucky 🤫">Feeling lucky 🤫</option>
<option value="Overheated 🥵">Overheated 🥵</option>
<option value="Playful 👻">Playful 👻</option>
<option value="Crying 😭">Crying 😭</option>
<option value="Sick 🤧">Sick 🤧</option>
<option value="Mischievous 😈">Mischievous 😈</option>
<option value="In love 🥰">In love 🥰</option>
<option value="Kissy face 😙">Kissy face 😙</option>
<option value="Cheeky 😋">Cheeky 😋</option>
<option value="Affectionate 😘">Affectionate 😘</option>
<option value="Annoyed 😠">Annoyed 😠</option>
<option value="Angry 😡">Angry 😡</option>
<option value="Furious 🤬">Furious 🤬</option>

         
        </select>
        

      </label>
            <label>
        PUNISHMENT
        <select name="dropdown2" placeholder="Dropdown2">
    
            <option value="Watch horror movies with me 👻">Watch horror movies with me 👻</option>
            <option value="Send me our previous chat screenshots 📸">Send me our previous chat screenshots 📸</option>
            <option value="Tell me our story like a fairytale 📖">Tell me our story like a fairytale 📖</option>
            <option value="Send me our whole love story ❤️">Send me our whole love story ❤️</option>
            <option value="I need to slap you (softly 😅)">I need to slap you (softly 😅)</option>
            <option value="One full day of household chores for you 🧹">One full day of household chores for you 🧹</option>
            <option value="Whole day of nonstop compliments 💬">Whole day of nonstop compliments 💬</option>
            <option value="Give me roses and flowers today 🌹">Give me roses and flowers today 🌹</option>
            <option value="Give me a sweet kiss 😘">Give me a sweet kiss 😘</option>
            <option value="Give me a warm hug now 🤗">Give me a warm hug now 🤗</option>
            <option value="I want to (gently!) beat you 😜">I want to beat you 😜</option>
            <option value="Push you into the drainage... just kidding! 💦">Push you into the drainage... 💦</option>
            <option value="Send me your cutest picture 📷">Send me your cutest picture 📷</option>
            <option value="You should spend 1 hour with me today ⏳">You should spend 1 hour with me today ⏳</option>
        </select>
        

      </label>

      <div className="labels">Severity</div>
      <label>
        <input type="radio" name="severity"  value="kitkat" defaultChecked />
        A chunky kitkat would fix this 👺
      </label>
      <label>
        <input type="radio" name="severity" value="time" />
        It would take time 👿
      </label>
      <label>
        <input type="radio" name="severity" value="breakup" />
        Let's Break Up 🤬
      </label>

      <button type="submit">Submit</button>
    </form>
    </div>
        
     

  )
}

  // ✅ This should be before the return


export default FormComponent;
